/* Ekaara Jharokha theme scripts. No dependencies. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Mobile navigation ---------- */
  function initNav() {
    var drawer = $('[data-mnav]');
    if (!drawer) return;
    var open = function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', drawer);
      if (first) first.focus();
    };
    var close = function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    $$('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    var track = $('[data-ann]');
    if (!track) return;
    var items = $$('.ann__item', track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4200);
  }

  /* ---------- Toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(message, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (linkText) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4600);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---------- Add to cart ---------- */
  function initAddToCart() {
    var form = $('[data-atc-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1) }]
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add this item.');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          toast('Added to your bag.', 'View bag', '/cart');
        })
        .catch(function (err) {
          toast(err.message || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var root = $('[data-variants]');
    if (!root) return;
    var jsonEl = $('[data-variant-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = $('[name="id"]', root) || $('[name="id"]');
    if (!idInput) return;
    var priceEl = $('[data-price]');
    var btn = $('[data-atc]');

    function apply(variantId) {
      var v = data.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      idInput.value = v.id;
      if (priceEl && v.priceHtml) priceEl.innerHTML = v.priceHtml;
      if (btn) {
        if (v.available) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-label') || 'Add to bag';
        } else {
          btn.disabled = true;
          btn.textContent = 'Sold out';
        }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-variant-input]', root).forEach(function (input) {
      input.addEventListener('change', function () { apply(input.value); });
      if (input.checked) apply(input.value);
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    $$('[data-qty]').forEach(function (box) {
      var input = $('input', box);
      $$('button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product rating badge (PDP) ----------
     Reviews are handled entirely by the Judge.me app block on this
     page. This theme-native badge only activates if the theme's own
     "Ratings and reviews" section is present and populated (.rvw__num
     / .rvw__n) — which it isn't. Rather than show an empty-state
     "Be the first to rate this piece" prompt, it simply stays hidden. */
  function initPdpRating() {
    var mount = $('[data-pdp-rating]');
    if (!mount) return;
    var scoreEl = $('.rvw__num');
    var countEl = $('.rvw__n');

    var score = scoreEl ? parseFloat(scoreEl.textContent) : NaN;
    var count = 0;
    if (countEl) {
      var countMatch = countEl.textContent.match(/\d+/);
      count = countMatch ? parseInt(countMatch[0], 10) : 0;
    }

    if (!count || isNaN(score)) {
      // No theme-native rating data. Leave the badge hidden (its
      // default state) instead of showing a placeholder prompt —
      // Judge.me's own widget covers reviews on this page.
      return;
    }

    var full = Math.round(score);
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += '<span class="pdp__star' + (i <= full ? ' is-filled' : '') + '">&#9733;</span>';
    }

    mount.innerHTML =
      '<a href="#reviews" class="pdp__rating-link">' +
      '<span class="pdp__stars" aria-hidden="true">' + stars + '</span>' +
      '<span class="pdp__rating-text">' + score.toFixed(1) + ' (' + count + (count === 1 ? ' rating' : ' ratings') + ')</span>' +
      '</a>';
    mount.hidden = false;
  }

  /* ---------- 3D product rail: drag-to-browse coverflow ---------- */
  function initRail() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('.e3d-rail-stage').forEach(function (stage) {
      var track = $('.e3d-rail-track', stage);
      if (!track) return;
      var cards = $$('.e3d-tag', track);
      if (!cards.length) return;

      var spacing = 190;
      function setSpacing() { spacing = stage.clientWidth < 620 ? 150 : 190; }
      setSpacing();
      window.addEventListener('resize', setSpacing);

      var centerIndex = 0;
      var velocity = 0;
      var dragging = false;
      var lastX = 0;
      var moved = 0;
      var autoplay = reduce ? 0 : 0.0009;
      var hovering = false;

      var running = false;

      function isActive() {
        return dragging || Math.abs(velocity) > 0.0003 || (!hovering && autoplay !== 0);
      }

      function paintCards() {
        var min = 0, max = cards.length - 1;
        if (centerIndex < min - 0.4) centerIndex = min - 0.4;
        if (centerIndex > max + 0.4) centerIndex = max + 0.4;

        cards.forEach(function (card, i) {
          var d = i - centerIndex;
          var absD = Math.abs(d);
          var x = d * spacing;
          var rotY = Math.max(-70, Math.min(70, d * -24));
          var z = -Math.min(absD, 4) * 70;
          var scale = 1 - Math.min(absD * 0.12, 0.42);
          var opacity = 1 - Math.min(absD * 0.24, 0.82);
          card.style.transform = 'translateX(' + x + 'px) translateZ(' + z + 'px) rotateY(' + rotY + 'deg) scale(' + scale + ')';
          card.style.opacity = opacity;
          card.style.zIndex = Math.round(1000 - absD * 10);
          card.style.pointerEvents = absD > 3.2 ? 'none' : 'auto';
        });
      }

      function frame() {
        if (!dragging) {
          if (!hovering) centerIndex += autoplay;
          centerIndex += velocity;
          velocity *= 0.9;
          if (Math.abs(velocity) < 0.0003) velocity = 0;
        }
        paintCards();

        if (isActive()) {
          requestAnimationFrame(frame);
        } else {
          running = false;
        }
      }

      function ensureLoop() {
        if (running) return;
        running = true;
        requestAnimationFrame(frame);
      }

      stage.addEventListener('pointerenter', function () { hovering = true; });
      stage.addEventListener('pointerleave', function () { hovering = false; ensureLoop(); });

      stage.addEventListener('pointerdown', function (e) {
        dragging = true; moved = 0;
        lastX = e.clientX;
        velocity = 0;
        stage.classList.add('is-dragging');
        stage.setPointerCapture(e.pointerId);
        ensureLoop();
      });
      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lastX;
        lastX = e.clientX;
        moved += Math.abs(dx);
        var delta = -dx / spacing;
        centerIndex += delta;
        velocity = delta;
      });
      function endDrag() {
        dragging = false;
        stage.classList.remove('is-dragging');
        ensureLoop();
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('pointerleave', endDrag);

      track.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); }
      }, true);

      // Paint the initial layout synchronously so the rail renders
      // correctly even when nothing ever starts the loop (e.g.
      // prefers-reduced-motion, where autoplay is 0 and the visitor
      // never hovers or drags).
      paintCards();
      if (isActive()) ensureLoop();
    });
  }

  /* ---------- Flip cards: brand pillars, tap or hover to reveal ---------- */
  function initFlipCards() {
    $$('.step-flip').forEach(function (card) {
      card.addEventListener('click', function () {
        var open = card.classList.toggle('is-flipped');
        card.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.rv');
    if (!items.length) return;

    var reveal = function (el) { el.classList.add('is-in'); };

    if (!('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (i) { io.observe(i); });

    var sweep = function () {
      $$('.rv:not(.is-in)').forEach(reveal);
    };
    setTimeout(sweep, 2000);
    window.addEventListener('load', function () { setTimeout(sweep, 500); });
  }

  /* ---------- Boot ---------- */
  function safe(fn) {
    try { fn(); } catch (e) {
      if (window.console && console.error) console.error('[theme]', fn.name, e);
    }
  }

  function boot() {
    safe(initNav);
    safe(initAnnouncement);
    safe(initAddToCart);
    safe(initVariants);
    safe(initQty);
    safe(initSort);
    safe(initPdpRating);
    safe(initRail);
    safe(initFlipCards);
    safe(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
